<template>
  <div class="cancel-complete">
    <div class="cancel-complete__head comp-head">
      <h1 class="comp-head__title">サブスクリプションの<br>解約手続きが<br>完了しました。</h1>
      <p class="comp-head__lead">登録中のメールアドレス「{{ userProfile.email }}」に確認メールを送りました。サービスは{{ peirodUntil }}まで引き続きお楽しみいただけます。</p>
    </div>
    <div class="cancel-complete__form comp-form">
      <p class="comp-form__lead">より良いサービスをお届けするため、ご意見ご感想をお聞かせいただけるとうれしいです。</p>
      <h2 class="comp-form__title">よろしければ解約の理由をお選びください。（いくつでも大丈夫です）</h2>
      <form-area
        :action="action"
        :method="method"
        :token="token"
      >
        <ul class="comp-form__checkbox">
          <li v-for="item in cancelReasonCheckbox.items" :key="item.value" class="comp-form__list">
            <BaseCheckbox
              :name="cancelReasonCheckbox.name"
              :value="item.value"
              :isChecked="reasonCheckbox.indexOf(item.value) !== -1"
              :validation="{}"
              @change="changeChecked"
            >
              <span v-html="item.label"></span>
            </BaseCheckbox>
          </li>
        </ul>
        <form-textarea
          class="comp-form__textarea"
          :name="cancelReasonTextarea.name"
          :value="reasonTextarea"
          :rows="5"
          :maxlength="cancelReasonTextarea.max"
          :placeholder="`詳しくご説明ください（${cancelReasonTextarea.max}文字）`"
          :validation="{ rules: { max: cancelReasonTextarea.max} }"
          @input="value => reasonTextarea = value"
        />
        <p class="comp-form__text">ご利用ありがとうございました。<br>またのご利用を心よりお待ちしております。</p>
        <submit-button
          type="submit"
          text="完了"
          :disabled="!reasonCheckbox.length"
        />
     </form-area>
    </div>
  </div>
</template>

<script>
import SubmitButton from '../partials/SubmitButton'
import BaseCheckbox from '../common/BaseCheckbox'

export default {
  name: "SubscCancelComplete",
  components: {
    BaseCheckbox,
    SubmitButton
  },
  props: {
    action: {
      type: String,
      default: ''
    },
    method: {
      type: String,
      default: 'POST'
    },
    token: {
      type: String,
      default: ''
    },
    cancelReasonCheckbox: {
      type: Object,
      default () {
        return {}
      }
    },
    cancelReasonTextarea: {
      type: Object,
      default () {
        return {}
      }
    },
    userProfile: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      // 期限
      peirodUntil: '［未設定］',
      // form 入力値
      reasonCheckbox: [],
      reasonTextarea: ''
    }
  },
  mounted () {
    // 期限日を代入
    const time = parseInt(this.userProfile.subscription.current_peirod_to) * 1000
    this.peirodUntil = window.moment(time).format('YYYY/M/D')
  },
  methods: {
    // reasonCheckbox 設定
    changeChecked (target) {
      const value = Number(target.value)
      const array = this.reasonCheckbox
      const index = array.indexOf(value)
      if (index >= 0 && !target.checked) { array.splice(index, 1) }
      else if (index === -1 && target.checked) { array.push(value) }
      array.sort()
    },
  }
}</script>

<style scoped lang="scss">
@import '../../../../sass/commons/commonVariables.scss';

.cancel-complete {
  color: $col_base_black;
  line-height: 1.57;
}
.comp-head {
  margin: 0 -16px;
  padding: 35px 20px 30px;
  border-bottom: 1px solid #DCDFE2;
  &__title {
    font-weight: bold;
    font-size: 26px;
    line-height: 1.3;
    text-align: center;
    margin: 0 0 30px;
  }
  &__lead {
    font-size: 13px;
    margin: 0;
  }
}
.comp-form {
  padding: 30px 4px;
  &__lead {
    font-size: 13px;
    text-align: justify;
    margin: 0 0 25px;
  }
  &__title {
    font-weight: bold;
    font-size: 16px;
    text-align: justify;
    padding: 0 0 16px;
    margin: 0;
    border-bottom: 1px solid #DCDFE2;
  }
  &__checkbox {
    padding: 20px 10px 10px;
    margin: 0;
  }
  &__list {
    display: block;
    margin: 0 0 15px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  &__textarea {
    padding: 0 0 0 40px;
    margin: 0 0 30px;
  }
  &__text {
    font-weight: bold;
    font-size: 16px;
    text-align: center;
    margin: 0;
  }
}
.submit-button {
  margin-top: 35px;
}
</style>

<style lang="scss">
.cancel-complete textarea {
  resize: none;
  font-size: 13px;
  padding: 10px 14px;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Subscription/SubscCancelComplete.vue